import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { Grid, Typography } from "@mui/material";

import styles from "./styles";

import { WhiteSpace } from "../";

import { MailIcon, PhoneIcon, GreenShadow } from "../../assets";

const Footer = () => {
  const { t: translation } = useTranslation();

  return (
    <div style={styles.stack}>
      <footer style={styles.footer}>
        <Grid container>
          <Grid item xs={12} md={3} lg={3} style={styles.gridItem}>
            <div>
              <Typography sx={styles.title}>
                {translation("footer.addressTitle") + ":"}
              </Typography>

              <WhiteSpace height="10px" />

              <Typography sx={styles.paragraph}>
                {translation("footer.address")}
              </Typography>

              <WhiteSpace height="10px" />

              <Typography sx={styles.title}>
                {translation("footer.contactTitle") + ":"}
              </Typography>

              <WhiteSpace height="5px" />

              <div style={styles.iconDiv}>
                <img src={PhoneIcon} alt="phone icon" style={styles.icon} />
                <Typography sx={styles.paragraph}>+961 70 390 859</Typography>
              </div>

              <WhiteSpace height="5px" />

              <div style={styles.iconDiv}>
                <img src={MailIcon} alt="mail icon" style={styles.icon} />
                <Typography sx={styles.paragraph}>info@netify.com</Typography>
              </div>
            </div>
          </Grid>

          <Grid item xs={12} md={3} lg={3} style={styles.gridItem}>
            <div>
              <Typography sx={styles.title}>
                {translation("footer.productsTitle")}
              </Typography>

              <WhiteSpace height="10px" />

              <NavLink style={styles.paragraph} to="">
                {translation("footer.forTeams")}
              </NavLink>

              <WhiteSpace height="5px" />

              <NavLink style={styles.paragraph} to="">
                {translation("footer.forIndividuals")}
              </NavLink>
            </div>
          </Grid>

          <Grid item xs={12} md={3} lg={3} style={styles.gridItem}>
            <div>
              <Typography sx={styles.title}>
                {translation("footer.companyTitle")}
              </Typography>

              <WhiteSpace height="10px" />

              <NavLink style={styles.paragraph} to="/about">
                {translation("footer.aboutUs")}
              </NavLink>

              <WhiteSpace height="5px" />

              <NavLink style={styles.paragraph} to="">
                {translation("footer.careers")}
              </NavLink>

              <WhiteSpace height="5px" />

              <NavLink style={styles.paragraph} to="">
                {translation("footer.newsroom")}
              </NavLink>

              <WhiteSpace height="5px" />

              <NavLink style={styles.paragraph} to="/contact">
                {translation("footer.contactUs")}
              </NavLink>
            </div>
          </Grid>

          <Grid item xs={12} md={3} lg={3} style={styles.gridItem}>
            <div>
              <Typography sx={styles.title}>
                {translation("footer.learnMoreTitle")}
              </Typography>

              <WhiteSpace height="10px" />

              <NavLink style={styles.paragraph} to="">
                {translation("footer.blog")}
              </NavLink>

              <WhiteSpace height="5px" />

              <NavLink
                style={styles.paragraph}
                to="/frequently-asked-questions"
              >
                {translation("footer.faqs")}
              </NavLink>
            </div>
          </Grid>
        </Grid>

        <WhiteSpace height="64px" />

        <div style={styles.divider} />

        <WhiteSpace height="24px" />

        <Typography sx={styles.copyright} component="p">
          {translation("footer.copyright")}
        </Typography>

        <WhiteSpace height="24px" />
      </footer>

      <img src={GreenShadow} style={styles.shadow} />
    </div>
  );
};

export default Footer;
